// extracted by mini-css-extract-plugin
export default {"LogoClasse":"Logo_LogoClasse__2DSOp","imageLogo":"Logo_imageLogo__Tqcm1"};